import EmployeeService from './EmployeeService.js';

export default EmployeeService;